import { getRequest, postRequest } from "../utils/axios";

export const giftsService = {
  list: (onSuccess, onError) => getRequest("/api/v1/gifts/", onSuccess, onError),
  send: (id, data, onSuccess, onError) =>
    postRequest(`/api/v1/gifts/${id}/send/`, data, onSuccess, onError),
  getPending: (onSuccess, onError) => getRequest("/api/v1/gifts/pending/", onSuccess, onError),
  respondPending: (accepted, onSuccess, onError) =>
    postRequest("/api/v1/gifts/pending/", { accepted }, onSuccess, onError),
  getClaim: (giftHash, onSuccess, onError) =>
    getRequest(`/api/v1/gifts/claim/${giftHash}/`, onSuccess, onError),
};
